import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import { useDefaultZIndex } from 'controls/react/ant/ant-select/hooks/useDefaultZIndex';
import React, { useMemo } from 'react';
import { getValueField } from 'controls/react/ant/ant-select/utils/getValueField';
import { getLabelField } from 'controls/react/ant/ant-select/utils/getLabelField';

export function useCustomDefaults<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { styles, showSearch, ...rest } = props;

	const stylesWrapped = useDefaultZIndex(styles);

	const showSearchActual = useMemo(() => {
		let result: typeof showSearch = showSearch;

		if (result === false) return result;

		if (result === null || result === undefined || result === true) {
			result = {};
		}

		result.optionFilterProp = getLabelField(props);

		return result;
	}, [showSearch]);

	return {
		allowClear: props.mode == 'multiple' || props.mode == 'tags',
		showSearch: showSearchActual,
		styles: stylesWrapped,
		...rest,
		defaultValue: props.defaultValue === null ? undefined : props.defaultValue,
		wrapper: props.wrapper ?? ((children: React.ReactNode) => children),
	};
}
